/**
 * CloudAlerts — dispatcher for the Cloud 5.0 emergency alerts page.
 * Routes V2 to CloudAlertsPage, V1 to CurrentCloudAlerts.
 */

import { Navigate } from 'react-router-dom';
import { ReactSession } from '../utils/ReactSession.jsx';
import { AES, enc } from 'crypto-js';
import CurrentCloudAlerts from './CurrentCloudAlerts.jsx';
import SessionReload from './component-assets/SessionReload.jsx';
import { compareRole, iAmHigherAuthority } from '../libs.jsx';
import { usePortalVersion } from '../contexts/PortalVersionContext.jsx';
import CloudAlertsPage from '../pages/events/alerts/CloudAlertsPage.jsx';

const CloudAlerts = (props) => {
    const { portalVersion } = usePortalVersion();
    const isV2 = portalVersion === 'v2';
    let dData, bData;

    if (ReactSession.get('PAL') != null) {
        bData = AES.decrypt(ReactSession.get('PAL'), import.meta.env.VITE_ESECRET);
        dData = JSON.parse(bData.toString(enc.Utf8));
    }

    const alertContent = isV2
        ? <CloudAlertsPage fullscreen={props.fullscreen} />
        : <CurrentCloudAlerts fullscreen={props.fullscreen} />;

    return (compareRole('', dData?.userrole) || iAmHigherAuthority(0, dData?.role_weight)) ? (
        <>
            {dData?.migrated && <SessionReload />}
            {alertContent}
        </>
    ) : <Navigate to={'/'} />;
};

export default CloudAlerts;
